// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__n0ZwX","heading":"styles_heading__3Q4xc","buttons":"styles_buttons__2SXyB"};